export default "__VITE_ASSET__DI73Jjkm__"